import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, reactive, ref, watch } from 'vue';
import { useCodeStore } from '@/services/useCodeStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import LlSelect from '@/components/LlSelect.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpenseCodePicker',
  props: {
  modelValue: {
    type: Object,
    required: false,
    default: () => ({ id: '', label: '' }),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'codeChange'],
  setup(__props, { emit: __emit }) {

const codeStore = useCodeStore();
const { handleError } = useSnackbarHandler();
const emit = __emit;

const props = __props;

const expenseRef = ref(null);
const selectedCode = ref(props.modelValue);

const expenseState = reactive({
  loading: false,
  expenseCodes: [],
});

onMounted(async () => {
  try {
    expenseState.loading = true;
    expenseState.expenseCodes = await codeStore.expenseCodes();
    populateSelected();
  } catch (error) {
    handleError(error);
  } finally {
    expenseState.loading = false;
  }
});

const populateSelected = () => {
  if (props.modelValue?.id) {
    selectedCode.value =
      expenseState.expenseCodes.find((e) => e.id === props.modelValue.id) ||
      props.modelValue;
  } else {
    selectedCode.value = { id: '', label: '' };
  }
};

const handleCodeChange = (value) => {
  selectedCode.value = value;
  emit('update:modelValue', value);
  emit('codeChange', value);
};

watch(
  () => props.modelValue,
  () => {
    populateSelected();
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LlSelect, {
    ref_key: "expenseRef",
    ref: expenseRef,
    class: "remove-all-input-styling",
    "data-cy": "expense-code-dropdown",
    label: "Expense Code",
    "label-class": "text-sm at-choose-client remove-outline",
    "is-autocomplete": "",
    clearable: "",
    "hide-details": true,
    "model-value": selectedCode.value,
    items: expenseState.expenseCodes,
    loading: expenseState.loading,
    placeholder: "Expense Code",
    "item-props": (item) => ({ disabled: item.disabled }),
    "menu-props": { maxWidth: expenseRef.value?.$el?.offsetWidth },
    disabled: __props.disabled,
    "onUpdate:modelValue": handleCodeChange
  }, null, 8, ["model-value", "items", "loading", "item-props", "menu-props", "disabled"]))
}
}

})